import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import StyledButton from "./StyledButton.jsx";

const StyledTextUpdate = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");
  const [tempValue, setTempValue] = useState(props.defaultValue);

  const containerProps = {
    spacing: props.spacing ? props.spacing : 1,
    sx: {
      width: props.containerWidth ? props.containerWidth : "100%",
    }
  }

  const textFieldProps = {
    label: props.label ? props.label : "",
    size: props.size ? props.size : "small",
    fullWidth: props.fullWidth ? props.fullWidth : true,
    variant: props.vairant ? props.variant : "outlined",
    sx: {
      backgroundColor: props.textFieldColor ? props.textFieldColor : "white",
      width: props.textFieldWidth ? props.textFieldWidth : "100%",
    },
    InputProps: {
      disableUnderline: props.enableUnderline ? false : true,
      sx: {
        borderRadius: props.borderRadius ? props.borderRadius : 0,
      },
    },
  };

  const handleEdit = () => {
    setIsEditing(true);
    setTempValue(value);
  };

  const handleSave = () => {
    setValue(tempValue);
    props.onSave(tempValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTempValue(value);
    setIsEditing(false);
  };

  useEffect(() => {
    if (props.defaultValue) {
      setTempValue(props.defaultValue);
      setValue(props.defaultValue);
    }
  }, [props]);

  return (
    <Stack
      direction="row"
      {...containerProps}
    >
      <Box sx={{ width: "100%" }}>
        <TextField
          value={isEditing ? tempValue : value}
          onChange={(e) => setTempValue(e.target.value)}
          disabled={!isEditing}
          defaultValue={tempValue}
          {...textFieldProps}
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        {isEditing ? (
          <Stack direction="row" spacing={1} sx={{ width: "50%" }}>
            <StyledButton onClick={handleSave} fontSize={14}>
              Save
            </StyledButton>
            <StyledButton
              onClick={handleCancel}
              fontSize={14}
              customTheme="outlined"
            >
              Cancel
            </StyledButton>
          </Stack>
        ) : (
          <StyledButton
            onClick={handleEdit}
            fontSize={14}
            customTheme="outlined"
            width="25%"
          >
            Edit
          </StyledButton>
        )}
      </Box>
    </Stack>
  );
};

export default StyledTextUpdate;
